module.exports = __webpack_public_path__ + "img/growthAbility2.4e337c7b.png";